import { AWStageDto } from '@api/Api';

type DefineIsPrevStageHasDeadlineType = {
  stages: AWStageDto[];
  stage: AWStageDto;
};
export default function defineIsPrevStageHasDeadline({
  stages,
  stage
}: DefineIsPrevStageHasDeadlineType) {
  const currentStageIndex = stages.findIndex((it) => it.id === stage.id);
  const stageWithNoDeadlineIndex = stages.findIndex((it) => !it.deadline);

  if (!currentStageIndex) return true;
  if (currentStageIndex !== 0 && stageWithNoDeadlineIndex === -1) return true;
  if (currentStageIndex <= stageWithNoDeadlineIndex) return true;

  const prevDeadline = stages.some(
    (it) => stageWithNoDeadlineIndex > currentStageIndex && it.deadline
  );
  return !!prevDeadline;
}
